// Actions
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'

export const LOAD_LAB_RESULTS = '@@hfty-reports/LOAD_LAB_RESULTS'
export const LOAD_MAP_REPORTS = '@@hfty-reports/LOAD_MAP_REPORTS'

export const SET_REPORTS = '@@hfty-reports/SET_REPORTS'
export const SET_REPORTS_ERRORS = '@@hfty-reports/SET_REPORTS_ERRORS'
export const START_SPINNER = '@@hfty-reports/START_SPINNER'
export const STOP_SPINNER = '@@hfty-reports/STOP_SPINNER'
export const DOWNLOAD_ZIP = '@@hfty-reports/DOWNLOAD_ZIP'

// State Configuration
export const TREE = 'reportsData'
export const REPORTS = 'reports'
export const REPORTS_ERRORS = 'reportsErrors'
export const IS_LOADING = 'isLoading'

// Constants
export const LAB_RESULT = 'labResult'
export const MAP_REPORT = 'mapReport'
export const LAB_REPORT = 'Lab Report'
export const PRESCRIPTION = 'Prescription'
export const RECOMMENDATION = 'Recommendation'
export const OTHER = 'Other'
export const LAB_ANALYSIS_MAP = 'Lab Analysis Map'

// URLs
export const SOIL_RESULTS_SHAPEFILE_URL = '/hefty/soiltestjobshapefile/'
